import React from 'react';
import styled from 'styled-components';
import { Section, Container, BlockTitle, t } from '../styles/shared';
import { resolveMediaServeUrl } from '../utils/mediaServeUrls';

const Grid = styled.div`
  display: grid; gap: 24px;
  ${({ $layout }) => $layout === 'grid' && 'grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));'}
  ${({ $layout }) => $layout === 'stacked' && 'max-width: 700px; margin: 0 auto;'}
`;

const Card = styled.div`
  padding: 32px; background: #fff;
  border: 1px solid ${t.border}; border-radius: 8px;
`;

const QuoteIcon = styled.svg`
  width: 32px; height: 32px; color: ${t.primary}; opacity: 0.3; margin-bottom: 12px;
`;

const Quote = styled.p`
  margin: 0; font-size: 1.125rem; font-style: italic; line-height: 1.6; color: ${t.text};
`;

const Author = styled.div`
  display: flex; align-items: center; gap: 12px; margin-top: 20px;
`;

const AuthorImg = styled.img`
  width: 48px; height: 48px; border-radius: 50%; object-fit: cover;
`;

const AuthorInfo = styled.div` display: flex; flex-direction: column; `;
const AuthorName = styled.span` font-weight: 600; color: ${t.text}; `;
const AuthorMeta = styled.span` font-size: 0.875rem; color: ${t.textLight}; `;

const Rating = styled.div`
  margin-top: 12px;
  .star { color: #ddd; }
  .star.filled { color: #f5a623; }
`;

const TestimonialBlock = ({ content = {}, settings = {}, tenantSlug, apiBase }) => {
  const { title = '', testimonials = [], layout = 'grid', showImages = true } = content;
  const { backgroundColor = '', padding = 'large' } = settings;
  if (!testimonials?.length) return null;

  return (
    <Section $padding={padding} $bgColor={backgroundColor}>
      <Container>
        {title && <BlockTitle style={{ textAlign: 'center' }}>{title}</BlockTitle>}
        <Grid $layout={layout}>
          {testimonials.map((t, i) => (
            <Card key={i}>
              <div>
                <QuoteIcon viewBox="0 0 24 24" fill="currentColor">
                  <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z"/>
                </QuoteIcon>
                <Quote>{t.quote}</Quote>
              </div>
              <Author>
                {showImages && t.image && (
                  <AuthorImg src={resolveMediaServeUrl(t.image, tenantSlug, apiBase) || t.image} alt={t.author} />
                )}
                <AuthorInfo>
                  <AuthorName>{t.author}</AuthorName>
                  {t.location && <AuthorMeta>{t.location}</AuthorMeta>}
                  {t.role && <AuthorMeta>{t.role}</AuthorMeta>}
                </AuthorInfo>
              </Author>
              {t.rating && (
                <Rating>
                  {[...Array(5)].map((_, j) => (
                    <span key={j} className={`star${j < t.rating ? ' filled' : ''}`}>★</span>
                  ))}
                </Rating>
              )}
            </Card>
          ))}
        </Grid>
      </Container>
    </Section>
  );
};

export default TestimonialBlock;
